import { ca } from '@cian/analytics';

import { createCianAnalyticsPageWithExtra } from '../../../utils/createCianAnalyticsPageWithExtra';
import { TDeviceType } from '@cian/ui-kit';

interface IParameters {
  name: string;
  query: string;
  suggestPos: string;
  totalSuggest: string;
  href: string;
  deviceType: TDeviceType;
  suggestType: string;
  isDuplicateSuggest: boolean;
}

export function trackSuggestClick({
  name,
  query,
  suggestPos,
  totalSuggest,
  href,
  deviceType,
  suggestType,
  isDuplicateSuggest,
}: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'search_string',
    label: href,
    page: createCianAnalyticsPageWithExtra({
      deviceType,
      extra: {
        clickType: 'search_suggest',
        searchQuery: query,
        suggestName: name,
        suggestPosition: suggestPos,
        suggestCount: totalSuggest,
        suggestType,
        isDuplicateSuggest: isDuplicateSuggest.toString(),
      },
    }),
  });
}
